// Register the StagePass service worker for PWA support
export function register() {
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        // Check for updates on every navigation
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === "installed" && navigator.serviceWorker.controller) {
              // New content available — emit a custom event the app can listen to
              window.dispatchEvent(new CustomEvent("swUpdate"));
            }
          };
        };
      })
      .catch((err) => console.warn("SW registration failed:", err));
  });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((r) => r.unregister());
  }
}
